// Theme store with persist + applyTheme bridge.

import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DEFAULT_THEME, type ThemeState, applyTheme } from "../../theme/tokens";

type Store = ThemeState & {
  set: (patch: Partial<ThemeState>) => void;
  reset: () => void;
};

export const useTheme = create<Store>()(
  persist(
    (set) => ({
      ...DEFAULT_THEME,
      set: (patch) =>
        set((prev) => {
          const next = { ...prev, ...patch };
          applyTheme(next);
          return next;
        }),
      reset: () => {
        applyTheme(DEFAULT_THEME);
        set(DEFAULT_THEME);
      },
    }),
    {
      name: "timple-theme",
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state);
      },
    },
  ),
);
